import useAuth from './useAuth';

export const useAuthHub = () => {
    const { auth } = useAuth(); // Suponiendo que 'auth' tiene la información del usuario

    const isAdmin = () => auth?.user?.role === "Administrador";

    return { isAdmin };
};
